import { render, staticRenderFns } from "./new-forgotpass.vue?vue&type=template&id=5cc1dfc7&scoped=true"
import script from "./new-forgotpass.vue?vue&type=script&lang=js"
export * from "./new-forgotpass.vue?vue&type=script&lang=js"
import style0 from "./new-forgotpass.vue?vue&type=style&index=0&id=5cc1dfc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc1dfc7",
  null
  
)

export default component.exports